import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconIronMapSizeS from './IconIronMap_size_s';

const props: CreateIconArguments = {
  l: IconIronMapSizeS,
  m: IconIronMapSizeS,
  s: IconIronMapSizeS,
  xs: IconIronMapSizeS,
  name: 'IconIronMap',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
